export default {
  banner: []
}